"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _RelatedMap = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/RelatedMap"));

// Generated by script, don't edit it please.
var RelatedMap = (0, _createSvgIcon["default"])({
  as: _RelatedMap["default"],
  ariaLabel: 'related map',
  category: 'charts',
  displayName: 'RelatedMap'
});
var _default = RelatedMap;
exports["default"] = _default;
module.exports = exports.default;